<template>
  <div class="auditHistoryTbl">
    <h1 v-b-toggle.recent-updates class="recent-updates-label">
      <a>Recent Updates</a>
      <font-awesome-icon :icon="expandStateIcon" class="float-right margin-point-4rem" />
    </h1>
    <b-collapse id="recent-updates" visible>
      <b-card>
        <ul class="basic-info">
          <li>
            <b class="label">Last Login:</b>
            {{recentInfo.lastLogin}}
          </li>
          <li>
            <b class="label">Last Modified By:</b>
            {{recentInfo.lastModifiedBy}}
          </li>
          <li>
            <b class="label">Last Modified Date:</b>
            {{recentInfo.lastModifiedDate}}
          </li>
          <li>
            <b class="label">Created By:</b>
            {{recentInfo.createdBy}}
          </li>
          <!-- <li>
                      <b>Created Date:</b>
                      {{recentInfo.createdDate}}
          </li>-->
        </ul>
      </b-card>
    </b-collapse>
    <h1 class="audit-history-label">Audit History</h1>
    <div class="container">
      <div class="row mb-2">
        <div class="md-3">Start Date</div>
        <div class="col-md-3">
          <vDatePicker
            v-model="startDate"
            @input="changefilter()"
            @change="changefilter()"
            @clear="changefilter()"
          ></vDatePicker>
        </div>
        <div class="md-3">End Date</div>
        <div class="col-md-3">
          <vDatePicker
            v-model="endDate"
            @input="changefilter()"
            @change="changefilter()"
            @clear="changefilter()"
          ></vDatePicker>
        </div>
      </div>
    </div>
    <b-table
      ref="auditHistoryTable"
      id="AuditHistoryTable"
      striped
      no-border-collapse
      sticky-header
      head-variant="head-border"
      :show-empty="showempty"
      :busy.sync="isBusy"
      :items="filterdlogEntries"
      :fields="columnsfield"
      :per-page="perPage"
      :current-page="currentPage"
      responsive
      class="tableTextColor"
    >
      <template v-slot:table-busy>
        <div class="text-center">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
      <template v-slot:cell(eventDate)="data">
        <a
          v-on:click="auditLoginfo(data,$event.target)"
          class="link"
          :title="formateGridDate(data.value)"
        >{{formateGridDate(data.value)}}</a>
      </template>
      <template v-slot:cell(accountNo)="data">
        <span :title="data.value">{{data.value}}</span>
      </template>
      <template v-slot:cell(eventDescription)="data">
          <span :title="data.value">{{data.value}}</span>
      </template>
      <template v-slot:cell(eventAddedBy)="data">
        <span :title="data.value">{{data.value}}</span>
      </template>
      <!--<template v-slot:cell(ipAddress)="data">
                <span :title="data.value">{{data.value}}</span>
            </template>
            <template v-slot:cell(browser)="data">
                <span :title="data.value">{{data.value}}</span>
      </template>-->
      <template v-slot:cell(fieldChanged)="data">
        <span :title="data.value">{{data.value}}</span>
      </template>
      <template v-slot:cell(priorValue)="data">
        <span :title="data.value">{{data.value}}</span>
      </template>
      <template v-slot:cell(newValue)="data">
        <span :title="data.value">{{data.value}}</span>
      </template>
    </b-table>
    <b-modal id="AuditinfoModal" size="lg"
             no-close-on-esc 
             no-close-on-backdrop>
      <template slot="modal-header">
        <h5 class="modal-title">Event Log</h5>
      </template>
      <div class="container">
        <div class="form-group">
          <table>
            <colgroup>
              <col style="width: 20%;" />
              <col style="width: 20%;" />
              <col style="width: 20%;" />
              <col style="width: 20%;" />
              <col style="width: 20%;" />
              <col style="width: 20%;" />
            </colgroup>
            <thead>
              <tr style="height:40px">
                <th>Event Id</th>
                <td>{{infoModal.title}}</td>
                <th>User</th>
                <td>{{userName}}</td>
              </tr>
              <tr style="height:40px">
                <th>Event Date</th>
                <td>{{infoModal.EventDate}}</td>
                <th>Account#</th>
                <td>{{infoModal.Account}}</td>
              </tr>
              <tr style="height:40px">
                <th>Event Type</th>
                <td>{{infoModal.eventTypeDescription}}</td>
                <th>Operator</th>
                <td>{{infoModal.Operator}}</td>
              </tr>
              <tr style="height:40px">
                <th>Browser</th>
                <td>{{infoModal.Browser}}</td>
                <th>IP Address</th>
                <td>{{infoModal.IpAddress}}</td>
              </tr>

              <tr style="height:40px">
                <th>Prior Value</th>
                <td>{{infoModal.priorValue}}</td>
                <th>New Value</th>
                <td>{{infoModal.newValue}}</td>
              </tr>
              <tr style="height:40px">
                <th>Field Changed</th>
                <td>{{infoModal.FieldChange}}</td>
                <th>Event Note</th>
                <td>{{infoModal.EventNote}}</td>
              </tr>
            </thead>
          </table>
          <div class="clear-both"></div>
        </div>
      </div>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button class="um-btn" @click="CloseAuditLogDetail()">Ok</b-button>
      </template>
    </b-modal>
    <div class="float-right">
      <span class="paginationCurrentPage mr-2 mt-1">Current page: {{currentPage}}</span>
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="AuditHistoryTable"
        align="right"
        size="sm"
      ></b-pagination>
    </div>
  </div>
</template>
<script>
//import service from "../../services/api.services";
import vDatePicker from "vue2-datepicker";
import "vue2-datepicker/locale/en";
import "vue2-datepicker/index.css";
export default {
  name: "AuditHistory",
  components: {
    vDatePicker
  },
  data() {
    return {
      recentInfo: {},
      logEntries: [],
      isBusy: true,
      showempty: true,
      fixed: true,
      perPage: 10,
      currentPage: 1,
      bordered: true,
      height: "",
      expandStateIcon: "plus-circle",
      startDate: "",
      endDate: "",
      filterdlogEntries: [],
      infoModal: {
        id: "info-modal",
        title: "",
        EventDate: "",
        Account: "",
        Operator: "",
        Browser: "",
        FieldChange: "",
        IpAddress: "",
        priorValue: "",
        newValue: "",
        EventName: "",
        EventTypeDescription: "",
        EventNote: ""
      }
    };
  },
  computed: {
    rows() {
      return this.filterdlogEntries.length;
    },
    columnsfield: function() {
      var fields = [
        {
          label: "Event Date",
          key: "eventDate",
          sortable: true,
          tdClass: [
            "text-nowrap",
            "tableContent",
            "audit-history-tdClass",
            "cell-ellipsis",
            "audit-col-3"
          ],
          thClass: ["text-nowrap", " tableContent", "audit-col-3", "audit-history-thClass"]
        },
        {
          label: "Account#",
          key: "accountNo",
          sortable: true,
          tdClass: [
            "text-nowrap",
            "tableContent",
            "audit-history-tdClass",
            "cell-ellipsis",
            "audit-col-1"
          ],
          thClass: ["text-nowrap", " tableContent", "audit-col-1", "audit-history-thClass"]
        },
        {
          label: "Event Type",
          key: "eventTypeDescription",
          sortable: true,
          tdClass: [
            "text-nowrap",
            "tableContent",
            "audit-history-tdClass",
            "cell-ellipsis",
            "audit-col-2"
          ],
          thClass: ["text-nowrap", " tableContent", "audit-col-3", "audit-history-thClass"]
        },
        {
          label: "Operator",
          key: "eventAddedBy",
          sortable: true,
          tdClass: [
            "text-nowrap",
            "tableContent",
            "audit-history-tdClass",
            "cell-ellipsis",
            "audit-col-1"
          ],
          thClass: ["text-nowrap", " tableContent", "audit-col-1", "audit-history-thClass"]
        },
        {
          label: "Field Changed",
          key: "fieldChanged",
          sortable: true,
          tdClass: [
            "text-nowrap",
            "tableContent",
            "audit-history-tdClass",
            "cell-ellipsis",
            "audit-col-3"
          ],
          thClass: ["text-nowrap", " tableContent", "audit-col-3", "audit-history-thClass"]
        },
        {
          label: "Prior Value",
          key: "priorValue",
          sortable: true,
          tdClass: [
            "text-nowrap",
            "tableContent",
            "audit-history-tdClass",
            "cell-ellipsis",
            "audit-col-1"
          ],
          thClass: ["text-nowrap", " tableContent", "audit-col-1", "audit-history-thClass"]
        },
        {
          label: "New Value",
          key: "newValue",
          sortable: true,
          tdClass: [
            "text-nowrap",
            "tableContent",
            "audit-history-tdClass",
            "cell-ellipsis",
            "audit-col-1"
          ],
          thClass: ["text-nowrap", " tableContent", "audit-col-1", "audit-history-thClass"]
        }
      ];
      return fields;
    }
  },
  props: {
    editingUserauditHistory: {},
    userName: String
  },
  created() {
    window.addEventListener("resize", this.handleHeightResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleHeightResize);
  },
  mounted() {
    this.getAuditHistory();
    this.handleHeightResize();
    var that = this;
    this.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
      if (collapseId == "recent-updates") {
        if (isJustShown) {
          that.expandStateIcon = "minus-circle";
        } else {
          that.expandStateIcon = "plus-circle";
        }
      }
    });
  },
  methods: {
    auditLoginfo: function(item, button) {
      //console.log(item);
      this.infoModal.EventDate = this.formateGridDate(item.item.eventDate);
      this.infoModal.Account = item.item.accountNo;
      this.infoModal.Operator = item.item.eventAddedBy;
      this.infoModal.Browser = item.item.browser;
      this.infoModal.IpAddress = item.item.ipAddress;
      this.infoModal.IpAddress = item.item.ipAddress;
      this.infoModal.newValue = item.item.newValue;
      this.infoModal.priorValue = item.item.priorValue;
      this.infoModal.EventName = item.item.eventName;
      this.infoModal.FieldChange = item.item.fieldChanged;
      this.infoModal.title = item.item.eventHistoryID;
      this.infoModal.eventTypeDescription = item.item.eventTypeDescription;
      this.infoModal.EventNote = item.item.eventNote;
      this.$root.$emit("bv::show::modal", "AuditinfoModal", button);
    },
    CloseAuditLogDetail: function() {
      this.$bvModal.hide("AuditinfoModal");
    },

    getAuditHistory: function() {
      var that = this;
      if (that.editingUserauditHistory != null) {
        that.recentInfo = that.editingUserauditHistory.recentInfo;
          that.logEntries = that.editingUserauditHistory.auditLogDetails;
        that.filterdlogEntries = that.logEntries;
      }
      that.isBusy = false;
    },
    handleHeightResize() {
      this.height =
        window.innerHeight -
        this.$refs.auditHistoryTable.offsetTop -
        100 +
        "px";
    },
    changefilter: function() {
      this.filterAugitLog();
    },
    filterAugitLog: function() {
      if (
        (this.startDate == undefined ||
          this.startDate == "" ||
          this.startDate == null) &&
        (this.endDate == "" ||
          this.endDate == null ||
          this.endDate == undefined)
      ) {
        this.filterdlogEntries = this.logEntries;
      } else if (
        this.startDate === null ||
        (this.startDate == "" && this.endDate != "")
      ) {
        this.filterdlogEntries = this.logEntries.filter(x => {
          return (
            new Date(this.formateDate(this.endDate)) >=
            new Date(this.formateDate(x.eventDate))
          );
        });
      } else if (
        this.endDate === null ||
        (this.endDate == "" && this.startDate != "")
      ) {
        this.filterdlogEntries = this.logEntries.filter(x => {
          return (
            new Date(this.formateDate(x.eventDate)) >=
            new Date(this.formateDate(this.startDate))
          );
        });
      } else {
        this.filterdlogEntries = this.logEntries.filter(x => {
          return (
            new Date(this.formateDate(x.eventDate)) >=
              new Date(this.formateDate(this.startDate)) &&
            new Date(this.formateDate(this.endDate)) >=
              new Date(this.formateDate(x.eventDate))
          );
        });
      }
    },
    formateDate: function(validDate) {
      const dateObj = new Date(validDate);
      const year = dateObj.getFullYear();
      const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
      const date = dateObj
        .getDate()
        .toString()
        .padStart(2, "0");

      return year + "-" + month + "-" + date;
    },
    formateGridDate: function(validDate) {
      const dateObj = new Date(validDate);
      var hours = dateObj.getHours();
      var minutes = dateObj.getMinutes();
      var ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var gridDate =
        ("00" + (dateObj.getMonth() + 1)).slice(-2) +
        "/" +
        ("00" + dateObj.getDate()).slice(-2) +
        "/" +
        dateObj.getFullYear() +
        " " +
        ("00" + hours).slice(-2) +
        ":" +
        ("00" + minutes).slice(-2) +
        ":" +
        ("00" + dateObj.getSeconds()).slice(-2) +
        " " +
        ampm;
      return gridDate;
    }
  }
};
</script>